import { render, staticRenderFns } from "./ServiceProviderContacts.vue?vue&type=template&id=7f500bc2&scoped=true&"
import script from "./ServiceProviderContacts.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderContacts.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviderContacts.vue?vue&type=style&index=0&id=7f500bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f500bc2",
  null
  
)

export default component.exports